import run from '../../utilities/run';
import render from '../../utilities/render';
import _ from "underscore";
import FxoConfigurationWizardLogic from './fxoConfigurationWizardLogic';

// NOTE: make the target selector a place on the webpage where you want to import this
const targetSelector = "#fxo-config-form";

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
  const fxoConfigurationWizardLogicVar = new FxoConfigurationWizardLogic(outerEl);
  fxoConfigurationWizardLogicVar.init();
};



// WEBPACK FOOTER //
// ./src/pages/fxoConfigurationForm/fxoConfigurationWizard.js